import { findControlsHoverDecoration, findColumnControlSelectedDecoration, updateNodeDecorations, createColumnSelectedDecorations, createColumnControlsDecoration, } from '../utils/decoration';
import { CellSelection } from 'prosemirror-tables';
import { TableDecorations } from '../types';
import { buildDecorationSet, noop } from './utils';
import { findTable } from 'prosemirror-utils';
var isColumnSelected = function (tr) {
    return tr.selection instanceof CellSelection && tr.selection.isColSelection();
};
// @see: https://product-fabric.atlassian.net/browse/ED-7304
var removeColumnControlsSelected = function (_a) {
    var decorationSet = _a.decorationSet;
    return decorationSet.remove(findColumnControlSelectedDecoration(decorationSet));
};
// @see: https://product-fabric.atlassian.net/browse/ED-3796
var removeControlsHover = function (_a) {
    var decorationSet = _a.decorationSet;
    return decorationSet.remove(findControlsHoverDecoration(decorationSet));
};
var createColumnSelected = function (_a) {
    var decorationSet = _a.decorationSet, tr = _a.tr;
    if (!isColumnSelected(tr)) {
        return decorationSet;
    }
    return updateNodeDecorations(tr.doc, decorationSet, createColumnSelectedDecorations(tr), TableDecorations.COLUMN_SELECTED);
};
var createColumnControls = function (_a) {
    var decorationSet = _a.decorationSet, tr = _a.tr;
    var table = findTable(tr.selection);
    if (!table) {
        return decorationSet;
    }
    return updateNodeDecorations(tr.doc, decorationSet, createColumnControlsDecoration(tr.selection), TableDecorations.COLUMN_CONTROLS_DECORATIONS);
};
export var buildTableDecorationSet = function (shouldRecreateColumnControls) { return function (_a) {
    var decorationSet = _a.decorationSet, tr = _a.tr;
    return buildDecorationSet([
        removeColumnControlsSelected,
        createColumnSelected,
        shouldRecreateColumnControls ? createColumnControls : noop,
        removeControlsHover,
    ])({ decorationSet: decorationSet, tr: tr });
}; };
//# sourceMappingURL=build-table-decoration-set.js.map